export enum TransferOrdersActionTypes {
  GET_LIST           = "TRANSFER_ORDERS_GET_LIST",
  GET_LIST_SUCCESS   = "TRANSFER_ORDERS_GET_LIST_SUCCESS",
  GET_LIST_ERROR     = "TRANSFER_ORDERS_GET_LIST_ERROR",

  CREATE             = "TRANSFER_ORDER_CREATE",
  CREATE_SUCCESS     = "TRANSFER_ORDER_CREATE_SUCCESS",
  CREATE_ERROR       = "TRANSFER_ORDER_CREATE_ERROR",

  GET_ONE            = "TRANSFER_ORDER_GET_ONE",
  GET_ONE_SUCCESS    = "TRANSFER_ORDER_GET_ONE_SUCCESS",
  GET_ONE_ERROR      = "TRANSFER_ORDER_GET_ONE_ERROR",

  UPDATE             = "TRANSFER_ORDER_UPDATE",
  UPDATE_SUCCESS     = "TRANSFER_ORDER_UPDATE_SUCCESS",
  UPDATE_ERROR       = "TRANSFER_ORDER_UPDATE_ERROR",

  UPDATE_STATUS      = "TRANSFER_ORDER_UPDATE_STATUS",
  UPDATE_STATUS_SUCCESS = "TRANSFER_ORDER_UPDATE_STATUS_SUCCESS",
  UPDATE_STATUS_ERROR   = "TRANSFER_ORDER_UPDATE_STATUS_ERROR",

  DELETE             = "TRANSFER_ORDER_DELETE",
  DELETE_SUCCESS     = "TRANSFER_ORDER_DELETE_SUCCESS",
  DELETE_ERROR       = "TRANSFER_ORDER_DELETE_ERROR",
}
